import React, { useEffect, useRef } from "react";
import { FocusManager } from "./../../../ui-components";
import styles from "./DropdownModal-scss";
const DropdownModal = ({ options, jsdomMode, dataHook }) => {
  const panelRef = useRef(null);
  useEffect(() => {
    const ref = panelRef.current;
    setTimeout(() => ref.focus(), 0);
  }, []);
  return /* @__PURE__ */ React.createElement("div", { tabIndex: -1, className: styles.modal, "data-hook": dataHook }, /* @__PURE__ */ React.createElement(FocusManager, { jsdomMode, preventScroll: true }, /* @__PURE__ */ React.createElement(
    "div",
    {
      tabIndex: 0,
      ref: panelRef,
      "data-hook": "dropdown-modal-options-wrapper",
      className: styles.dropdownModalOptionsWrapper
    },
    options
  )));
};
var DropdownModal_default = DropdownModal;
export {
  DropdownModal_default as default
};
//# sourceMappingURL=DropdownModal.js.map
